import axios from "axios";

export const fetchGoalCategories = (token) => async (dispatch) => {
  dispatch({ type: "FETCH_GOAL_CATEGORY_REQUEST" });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/getGoalCategory`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({ type: "FETCH_GOAL_CATEGORY_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "FETCH_GOAL_CATEGORY_FAILURE", payload: error.message });
  }
};
